import { render, staticRenderFns } from "./CollectionItemCard.vue?vue&type=template&id=9ab8ac72&scoped=true&"
import script from "./CollectionItemCard.vue?vue&type=script&lang=js&"
export * from "./CollectionItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItemCard.vue?vue&type=style&index=0&id=9ab8ac72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab8ac72",
  null
  
)

export default component.exports